import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "image", "deleteButton", "setPrimaryButton"]
  static values = { deleteUrl: String, setPrimaryUrl: String, isCover: Boolean }

  open(event) {
    const trigger = event.currentTarget
    const imgSrc = trigger.dataset.lightboxSrc
    const deleteUrl = trigger.dataset.lightboxDeleteUrl
    const setPrimaryUrl = trigger.dataset.lightboxSetPrimaryUrl
    const isCover = trigger.dataset.lightboxIsCover === "true"

    this.imageTarget.src = imgSrc
    this.deleteUrlValue = deleteUrl
    this.setPrimaryUrlValue = setPrimaryUrl || ""
    this.isCoverValue = isCover

    this.deleteButtonTarget.dataset.url = deleteUrl

    if (this.hasSetPrimaryButtonTarget) {
      if (isCover || !setPrimaryUrl) {
        this.setPrimaryButtonTarget.classList.add("hidden")
      } else {
        this.setPrimaryButtonTarget.classList.remove("hidden")
        this.setPrimaryButtonTarget.dataset.url = setPrimaryUrl
      }
    }

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    if (event.target === this.modalTarget || event.currentTarget.dataset.action?.includes("close")) {
      this.modalTarget.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.modalTarget.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }

  async delete(event) {
    const message = this.isCoverValue
      ? "This is your cover photo. Deleting it will remove your book's cover image. Are you sure?"
      : "Are you sure you want to delete this photo? This cannot be undone."

    if (!confirm(message)) return

    const url = event.currentTarget.dataset.url
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    })

    if (response.ok) {
      this.close({ target: this.modalTarget })
      window.location.reload()
    }
  }

  async setPrimary(event) {
    const url = event.currentTarget.dataset.url
    if (!url) return

    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    })

    if (response.ok) {
      window.location.reload()
    }
  }
}
